export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Par formule"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun contrat sur la période sélectionnée"])},
        "scroll_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faire défiler pour voir les autres formules"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By plan"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No contracts for the selected period"])},
        "scroll_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scroll to see the other plans"])}
      }
    }
  })
}
